export default __webpack_public_path__ + "static/media/cloud-download.34d34f78.svg";